export function useTechTheme (certificationId) {
  const certs = useCertifications()
  const catalog = useCatalog()
  const tech = useTech()

  const currentTheme = computed(() => certificationId ? getCurrentTheme(certificationId) : getTheme(tech.id))
  const currentLevel = computed(() => certificationId ? getCertificationLevelById(certificationId) : null)

  useProseTheme(tech.id, currentLevel.value || 'junior')

  const techThemeVariables = {
    vuejs: {
      intermediate: {
        heading: 'heading-primary',
        textColor: '!text-mint',
        textColorHover: 'hover:text-mint',
        borderColor: 'border-mint',
        bgColorHover: 'hover:bg-mint',
        bgColor: 'bg-mint',
        bgColorTransparent: 'bg-mint/20',
        bgColorGradient: 'bg-gradient-to-r from-mint to-cerulean',
        bgColorGradientTransparent: 'bg-gradient-to-r from-mint/20 to-cerulean/20',
        shadowColor: 'shadow-mint',
        shadowColorTransparent: 'shadow-mint/40',
        button: 'btn-primary disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-primary-outline',
        buttonLink: 'btn-primary-link',
        prose: '[&>blockquote>p]:!text-light-gray  [&>blockquote>p]:dark:!text-light-gray'
      },
      senior: {
        heading: 'heading-secondary',
        textColor: 'text-brilliant-rose',
        textColorHover: 'hover:text-brilliant-rose',
        borderColor: 'border-brilliant-rose',
        bgColor: 'bg-brilliant-rose',
        bgColorHover: 'hover:bg-brilliant-rose',
        bgColorTransparent: 'bg-brilliant-rose/20',
        bgColorGradient: 'bg-gradient-to-r from-brilliant-rose to-dodger-blue',
        bgColorGradientTransparent: 'bg-gradient-to-r from-brilliant-rose/20 to-dodger-blue/20',
        shadowColor: 'shadow-brilliant-rose',
        shadowColorTransparent: 'shadow-brilliant-rose/40',
        button: 'btn-secondary disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-secondary-outline',
        buttonLink: 'btn-secondary-link',
        prose: '[&>blockquote>p]:!text-light-gray  [&>blockquote>p]:dark:!text-light-gray'
      }
    },
    nuxt: {
      intermediate: {
        heading: 'heading-primary',
        textColor: 'text-nuxt-green',
        textColorHover: 'hover:text-nuxt-green',
        borderColor: 'border-nuxt-green',
        bgColor: 'bg-nuxt-green',
        bgColorHover: 'hover:bg-nuxt-green',
        bgColorTransparent: 'bg-nuxt-green/20',
        bgColorGradient: 'bg-gradient-to-r from-nuxt-green to-nuxt-green',
        bgColorGradientTransparent: 'bg-gradient-to-r from-nuxt-green/20 to-nuxt-green/20',
        shadowColor: 'shadow-nuxt-green',
        shadowColorTransparent: 'shadow-nuxt-green/40',
        button: 'btn-primary disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-primary-outline',
        buttonLink: 'btn-primary-link',
        cardBg: 'bg-white dark:bg-dark-metal',
        prose: '[&>blockquote>p]:!text-quartz  [&>blockquote]:!bg-nuxt-green/20  [&>blockquote>p]:dark:!text-light-gray'
      },
      senior: {
        heading: 'heading-secondary',
        textColor: 'text-bittersweet',
        textColorHover: 'hover:text-bittersweet',
        borderColor: 'border-bittersweet',
        bgColorHover: 'hover:bg-bittersweet',
        bgColor: 'bg-bittersweet',
        bgColorTransparent: 'bg-bittersweet/20',
        bgColorGradient: 'bg-gradient-to-r from-bittersweet to-bittersweet',
        bgColorGradientTransparent: 'bg-gradient-to-r from-bittersweet/20 to-bittersweet/20',
        shadowColor: 'shadow-bittersweet',
        shadowColorTransparent: 'shadow-bittersweet/40',
        button: 'btn-secondary disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-secondary-outline',
        buttonLink: 'btn-secondary-link',
        cardBg: 'bg-white dark:bg-dark-metal',
        prose: '[&>blockquote>p]:!text-light-gray  [&>blockquote>p]:dark:!text-light-gray'
      }
    },
    angular: {
      junior: {
        heading: 'text-quartz dark:text-white [&>em]:!text-angular-pink',
        textColor: 'text-angular-pink',
        textColorHover: 'hover:text-angular-pink',
        borderColor: 'border-angular-pink',
        bgColor: 'bg-angular-pink',
        bgColorHover: 'hover:bg-angular-pink',
        bgColorTransparent: 'bg-angular-pink/20',
        bgColorGradient: 'bg-gradient-to-r from-angular-pink to-angular-purple',
        bgColorGradientTransparent: 'bg-gradient-to-r from-angular-pink/20 to-angular-purple/20',
        shadowColor: 'shadow-angular-pink',
        shadowColorTransparent: 'shadow-angular-pink/40',
        button: 'btn bg-angular-pink !text-white hover:cursor-pointer hover:bg-angular-pink/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-outline border-2 border-angular-pink font-bold hover:cursor-pointer hover:bg-none hover:bg-angular-pink/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonLink: 'btn-link !text-angular-pink bg-transparent',
        prose: '[&>blockquote>p]:!text-quartz  [&>blockquote>p]:dark:!text-light-gray'
      },
      intermediate: {
        heading: 'text-quartz dark:text-white [&>em]:!text-angular-purple',
        textColor: 'text-angular-purple',
        textColorHover: 'hover:text-angular-purple',
        borderColor: 'border-angular-purple',
        bgColor: 'bg-angular-purple',
        bgColorHover: 'hover:bg-angular-purple',
        bgColorTransparent: 'bg-angular-purple/20',
        bgColorGradient: 'bg-gradient-to-r from-angular-purple to-angular-purple',
        bgColorGradientTransparent: 'bg-gradient-to-r from-angular-purple/20 to-angular-purple/20',
        shadowColor: 'shadow-angular-purple',
        shadowColorTransparent: 'shadow-angular-purple/40',
        button: 'btn bg-angular-purple !text-white hover:cursor-pointer hover:bg-angular-purple/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-outline border-2 border-angular-purple font-bold hover:cursor-pointer hover:bg-none hover:bg-angular-purple/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonLink: 'btn-link !text-angular-purple bg-transparent',
        prose: '[&>blockquote>p]:!text-quartz  [&>blockquote>p]:dark:!text-light-gray'
      },
      senior: {
        heading: 'text-quartz dark:text-white [&>em]:!text-angular-mint',
        textColor: 'text-angular-mint',
        textColorHover: 'hover:text-angular-mint',
        borderColor: 'border-angular-mint',
        bgColor: 'bg-angular-mint',
        bgColorHover: 'hover:bg-angular-mint',
        bgColorTransparent: 'bg-angular-mint/20',
        bgColorGradient: 'bg-gradient-to-r from-angular-mint to-angular-mint',
        bgColorGradientTransparent: 'bg-gradient-to-r from-angular-mint/20 to-angular-mint/20',
        shadowColor: 'shadow-angular-mint',
        shadowColorTransparent: 'shadow-angular-mint/40',
        button: 'btn bg-angular-mint !text-white hover:cursor-pointer hover:bg-angular-mint/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-outline border-2 border-angular-mint font-bold hover:cursor-pointer hover:bg-none hover:bg-angular-mint/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonLink: 'btn-link !text-angular-mint bg-transparent',
        prose: '[&>blockquote>p]:!text-quartz  [&>blockquote>p]:dark:!text-light-gray'
      }
    },
    javascript: {
      junior: {
        heading: 'dark:text-white [&>em]:!text-js-yellow',
        textColor: 'text-js-yellow',
        textColorHover: 'hover:text-js-yellow',
        borderColor: 'border-js-yellow',
        bgColor: 'bg-js-yellow',
        bgColorHover: 'hover:bg-js-yellow',
        bgColorTransparent: 'bg-js-yellow/20',
        bgColorGradient: 'bg-gradient-to-r from-js-yellow to-js-yellow',
        bgColorGradientTransparent: 'bg-gradient-to-r from-js-yellow/20 to-js-yellow/20',
        shadowColor: 'shadow-js-yellow',
        shadowColorTransparent: 'shadow-js-yellow/40',
        button: 'btn bg-js-yellow !text-eerie-black hover:cursor-pointer hover:bg-js-yellow/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-outline border-2 border-js-yellow font-bold hover:cursor-pointer hover:bg-none hover:bg-js-yellow/80 hover:text-eerie-black transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonLink: 'btn-link !text-js-yellow bg-transparent'
      },
      intermediate: {
        heading: 'dark:text-white [&>em]:!text-js-magenta',
        textColor: 'text-js-magenta',
        textColorHover: 'hover:text-js-magenta',
        borderColor: 'border-js-magenta',
        bgColor: 'bg-js-magenta',
        bgColorHover: 'hover:bg-js-magenta',
        bgColorTransparent: 'bg-js-magenta/20',
        bgColorGradient: 'bg-gradient-to-r from-js-magenta to-js-magenta',
        bgColorGradientTransparent: 'bg-gradient-to-r from-js-magenta/20 to-js-magenta/20',
        shadowColor: 'shadow-js-magenta',
        shadowColorTransparent: 'shadow-js-magenta/40',
        button: 'btn bg-js-magenta !text-white hover:cursor-pointer hover:bg-js-magenta/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-outline border-2 border-js-magenta font-bold hover:cursor-pointer hover:bg-none hover:bg-js-magenta/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonLink: 'btn-link !text-js-magenta bg-transparent'
      },
      senior: {
        heading: 'dark:text-white [&>em]:!text-js-mint',
        textColor: 'text-js-mint',
        textColorHover: 'hover:text-js-mint',
        borderColor: 'border-js-mint',
        bgColor: 'bg-js-mint',
        bgColorHover: 'hover:bg-js-mint',
        bgColorTransparent: 'bg-js-mint/20',
        bgColorGradient: 'bg-gradient-to-r from-js-mint to-js-mint',
        bgColorGradientTransparent: 'bg-gradient-to-r from-js-mint/20 to-js-mint/20',
        shadowColor: 'shadow-js-mint',
        shadowColorTransparent: 'shadow-js-mint/40',
        button: 'btn bg-js-mint !text-eerie-black hover:cursor-pointer hover:bg-js-mint/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'border-2 border-js-mint font-bold hover:cursor-pointer hover:text-eerie-black transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none btn-outline hover:!bg-none hover:!bg-js-mint/80',
        buttonLink: 'btn-link !text-js-mint bg-transparent'
      }
    },
    react: {
      junior: {
        heading: 'dark:text-white [&>em]:!text-react-blue',
        textColor: 'text-react-blue',
        textColorHover: 'hover:text-react-blue',
        borderColor: 'border-react-blue',
        bgColor: 'bg-react-blue',
        bgColorHover: 'hover:bg-react-blue',
        bgColorTransparent: 'bg-react-blue/20',
        bgColorGradient: 'bg-gradient-to-r from-react-blue to-react-blue',
        bgColorGradientTransparent: 'bg-gradient-to-r from-react-blue/20 to-react-blue/20',
        shadowColor: 'shadow-react-blue',
        shadowColorTransparent: 'shadow-react-blue/40',
        button: 'btn bg-react-blue !text-eerie-black hover:cursor-pointer hover:bg-react-blue/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-outline border-2 border-react-blue font-bold hover:cursor-pointer hover:bg-none hover:bg-react-blue/80 hover:text-eerie-black transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonLink: 'btn-link !text-react-blue bg-transparent'
      },
      intermediate: {
        heading: 'dark:text-white [&>em]:!text-react-orange',
        textColor: 'text-react-orange',
        textColorHover: 'hover:text-react-orange',
        borderColor: 'border-react-orange',
        bgColor: 'bg-react-orange',
        bgColorHover: 'hover:bg-react-orange',
        bgColorTransparent: 'bg-react-orange/20',
        bgColorGradient: 'bg-gradient-to-r from-react-orange to-react-orange',
        bgColorGradientTransparent: 'bg-gradient-to-r from-react-orange/20 to-react-orange/20',
        shadowColor: 'shadow-react-orange',
        shadowColorTransparent: 'shadow-react-orange/40',
        button: 'btn bg-react-orange !text-white hover:cursor-pointer hover:bg-react-orange/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-outline border-2 border-react-orange font-bold hover:cursor-pointer hover:bg-none hover:bg-react-orange/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonLink: 'btn-link !text-react-orange bg-transparent'
      },
      senior: {
        heading: 'dark:text-white [&>em]:!text-react-green',
        textColor: 'text-react-green',
        textColorHover: 'hover:text-react-green',
        borderColor: 'border-react-green',
        bgColor: 'bg-react-green',
        bgColorHover: 'hover:bg-react-green',
        bgColorTransparent: 'bg-react-green/20',
        bgColorGradient: 'bg-gradient-to-r from-react-green to-react-green',
        bgColorGradientTransparent: 'bg-gradient-to-r from-react-green/20 to-react-green/20',
        shadowColor: 'shadow-react-green',
        shadowColorTransparent: 'shadow-react-green/40',
        button: 'btn bg-react-green !text-eerie-black hover:cursor-pointer hover:bg-react-green/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'border-2 border-react-green font-bold hover:cursor-pointer hover:text-eerie-black transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none btn-outline hover:!bg-none hover:!bg-react-green/80',
        buttonLink: 'btn-link !text-react-green bg-transparent'
      }
    },
    typescript: {
      junior: {
        heading: 'dark:text-white [&>em]:!text-ts-blue',
        textColor: 'text-ts-blue',
        textColorHover: 'hover:text-ts-blue',
        borderColor: 'border-ts-blue',
        bgColor: 'bg-ts-blue',
        bgColorHover: 'hover:bg-ts-blue',
        bgColorTransparent: 'bg-ts-blue/20',
        bgColorGradient: 'bg-gradient-to-r from-ts-blue to-ts-blue',
        bgColorGradientTransparent: 'bg-gradient-to-r from-ts-blue/20 to-ts-blue/20',
        shadowColor: 'shadow-ts-blue',
        shadowColorTransparent: 'shadow-ts-blue/40',
        button: 'btn bg-ts-blue !text-eerie-black hover:cursor-pointer hover:bg-ts-blue/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-outline border-2 border-ts-blue font-bold hover:cursor-pointer hover:bg-none hover:bg-ts-blue/80 hover:text-eerie-black transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonLink: 'btn-link !text-ts-blue bg-transparent'
      },
      intermediate: {
        heading: 'dark:text-white [&>em]:!text-ts-blue',
        textColor: 'text-ts-blue',
        textColorHover: 'hover:text-ts-blue',
        borderColor: 'border-ts-blue',
        bgColor: 'bg-ts-blue',
        bgColorHover: 'hover:bg-ts-blue',
        bgColorTransparent: 'bg-ts-blue/20',
        bgColorGradient: 'bg-gradient-to-r from-ts-blue to-ts-blue',
        bgColorGradientTransparent: 'bg-gradient-to-r from-ts-blue/20 to-ts-blue/20',
        shadowColor: 'shadow-ts-blue',
        shadowColorTransparent: 'shadow-ts-blue/40',
        button: 'btn bg-ts-blue !text-white hover:cursor-pointer hover:bg-ts-blue/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'btn-outline border-2 border-ts-blue font-bold hover:cursor-pointer hover:bg-none hover:bg-ts-blue/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonLink: 'btn-link !text-ts-blue bg-transparent'
      },
      senior: {
        heading: 'dark:text-white [&>em]:!text-ts-blue',
        textColor: 'text-ts-blue',
        textColorHover: 'hover:text-ts-blue',
        borderColor: 'border-ts-blue',
        bgColor: 'bg-ts-blue',
        bgColorHover: 'hover:bg-ts-blue',
        bgColorTransparent: 'bg-ts-blue/20',
        bgColorGradient: 'bg-gradient-to-r from-ts-blue to-ts-blue',
        bgColorGradientTransparent: 'bg-gradient-to-r from-ts-blue/20 to-ts-blue/20',
        shadowColor: 'shadow-ts-blue',
        shadowColorTransparent: 'shadow-ts-blue/40',
        button: 'btn bg-ts-blue !text-eerie-black hover:cursor-pointer hover:bg-ts-blue/80 transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none',
        buttonOutline: 'border-2 border-ts-blue font-bold hover:cursor-pointer hover:text-eerie-black transition duration-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none btn-outline hover:!bg-none hover:!bg-ts-blue/80',
        buttonLink: 'btn-link !text-ts-blue bg-transparent'
      }
    }
  }

  const lowestLevelTheme = computed(() => {
    const theme = techThemeVariables[tech.id]
    return theme?.junior || theme?.intermediate
  })

  function getTechTheme (_tech) {
    const techThemes = {
      vuejs: 'theme-vue',
      angular: 'theme-angular',
      javascript: 'theme-javascript',
      nuxt: 'theme-nuxt',
      typescript: 'theme-typescript',
      react: 'theme-react'
    }

    return techThemes[_tech]
  }

  function getCertificationLevel (slug) {
    if (!slug) {
      return
    }

    const cert = certs.list.find(c => c.slug === slug)
    if (cert) {
      const { display_level } = cert
      if (display_level) {
        return {
          junior: 'junior',
          intermediate: 'intermediate',
          senior: 'senior'
        }[display_level]
      }
    }

    // A fallback detection using slug
    if (slug.includes('senior') || slug.includes('level-3')) {
      return 'senior'
    } else if (slug.includes('junior') || slug.includes('level-1')) {
      return 'junior'
    } else {
      return 'intermediate'
    }
  }

  function getBundleType (slug) {
    const bundle = Object.values(catalog.list).find(c => c.slug === slug)
    if (bundle?.type) {
      return bundle.type
    }

    const availableBundleTypes = [
      'examination-only',
      'examination-and-training-bundle',
      'examination-training-and-online-bootcamp-bundle'
    ]

    for (const bundleType of availableBundleTypes) {
      if (slug.includes(bundleType)) return bundleType
    }

    return slug
  }

  function getBundleLevel (item) {
    return item.products.reduce((acc, product) => {
      const certLevel = getCertificationLevelById(product.certification_id)
      if (!acc) return certLevel
      if (certLevel === acc) return acc

      const rankedLevels = {
        senior: 3,
        intermediate: 2,
        junior: 1
      }
      if (rankedLevels[certLevel] > rankedLevels[acc]) return certLevel

      return 'junior'
    }, null)
  }

  function getCertificationLevelById (id) {
    if (!certs.list?.length) return 'senior'
    const cert = certs.list?.find(c => c.id === id)
    return cert ? getCertificationLevel(cert.slug) : 'senior'
  }

  function getCurrentTheme (certId) {
    if (!certId || !certs.list?.length) {
      return null
    }

    const currentCert = certs.list?.find((c) => c.id === certId)
    const level = getCertificationLevel(currentCert?.slug)
    return techThemeVariables?.[tech.id]?.[level]
  }

  function getTheme (techId, level = null) {
    if (!level) {
      return techThemeVariables?.[techId]
    }
    return techThemeVariables?.[techId]?.[level]
  }

  return {
    techThemeVariables,
    currentTheme,
    currentLevel,
    lowestLevelTheme,

    getTechTheme,
    getCurrentTheme,
    getCertificationLevel,
    getBundleType,
    getBundleLevel,
    getCertificationLevelById,
    getTheme
  }
}
